import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SurveySectionComponent } from "./survey-section/survey-section.component";
import { SurveyComponent } from "./survey.component";
import { SharedModules } from "src/app/shared.modules";
import { QuestionModule } from "../question/question.module";
import { AngularSvgIconModule } from "angular-svg-icon";
import { ButtonComponent } from "../button/button.component";
@NgModule({
  declarations: [SurveyComponent, SurveySectionComponent],
  imports: [
    CommonModule,
    SharedModules,
    QuestionModule,
    AngularSvgIconModule,
    ButtonComponent,
  ],
  exports: [SurveyComponent, SurveySectionComponent],
})
export class SurveyModule {}
